import { PostLeasing, Values } from 'src/screens/B2bLeasing/page/types'

import { apiSlice } from '@/shared/api/apiSlice'

export const insuranceApi = apiSlice.injectEndpoints({
	endpoints: build => ({
		postInsuranceForm: build.mutation<PostLeasing, Values>({
			query: data => ({
				url: `b24-lead-add`,
				method: 'POST',
				params: {
					TYPE: 'InsuranceB2B',
					SCRIPT_ID: 340508,
					...data
				},
				body: JSON.stringify({ ...data })
			})
		})
	})
})

export const { usePostInsuranceFormMutation } = insuranceApi
